import { atom } from 'recoil'
import { BEQUEUE_CONFIG_STATE_RUNNING } from 'Api/beQueueApi'

export const SENDING_METHOD_TYPE_FREQUENCY = 1

export const progressState = atom({
  key: 'EmailSendingWizardProgressBarState',
  default: {
    loading: false,
    loaded: false,
    queueStatus: BEQUEUE_CONFIG_STATE_RUNNING,
    variant: 'default',
    toBeQueued: 0,
    queued: 0,
    queuedPercentage: 0,
    bandwidth: undefined,
    sendMethodType: undefined,
    estimatedSendingTime: undefined
  }
})

export const manageButtonsState = atom({
  key: 'EmailSendingWizardManageButtonsState',
  default: {
    retryDisabled: false,
    deleteDisabled: false
  }
})
